import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Logo } from "../components/Logo";
import { useAuth } from "../lib/auth";
import { ArrowRight } from "@phosphor-icons/react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) {
      const to = loc.state?.from || "/feed";
      nav(to);
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2 bg-[#0A0A0C]" data-testid="login-page">
      <div className="hidden md:flex flex-col justify-between p-10 blueprint-grid border-r border-[#27272A]">
        <Link to="/"><Logo size={30} /></Link>
        <div>
          <div className="label-mono mb-4" style={{ color: "#E60012" }}>SESSION · AUTH</div>
          <h1 className="font-display text-white" style={{ fontSize: 56, fontWeight: 900, letterSpacing: "-0.035em", lineHeight: 0.95 }}>
            Welcome back<br />to the hangar.
          </h1>
          <p className="text-zinc-400 mt-6 max-w-md">
            Pick up the threads where you left them. Your hubs, your replies, your transcripts — all waiting.
          </p>
        </div>
        <div className="label-mono">IAAM/AUTH/001</div>
      </div>

      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-md" data-testid="login-form">
          <Link to="/" className="md:hidden mb-8 inline-block"><Logo size={26} /></Link>
          <div className="label-mono mb-2">SIGN IN</div>
          <h2 className="font-display text-white mb-8" style={{ fontSize: 32, fontWeight: 900, letterSpacing: "-0.03em" }}>
            Enter iAAM
          </h2>

          <label className="label-mono block mb-1.5">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="input mb-4"
            placeholder="you@aerospace.io"
            data-testid="login-email-input"
          />

          <label className="label-mono block mb-1.5">Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="input mb-6"
            placeholder="••••••••"
            data-testid="login-password-input"
          />

          {error && (
            <div className="mb-4 text-sm text-red-500 border border-red-900/50 bg-red-950/30 px-3 py-2" data-testid="login-error">
              {error}
            </div>
          )}

          <button type="submit" disabled={busy} className="btn btn-primary w-full" data-testid="login-submit-btn">
            {busy ? <span className="spinner" /> : <>Sign in <ArrowRight size={14} weight="bold" /></>}
          </button>

          <p className="text-sm text-zinc-400 mt-6 text-center">
            New here?{" "}
            <Link to="/register" className="text-white underline-offset-4 hover:underline" data-testid="login-to-register-link">
              Create an account
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}
